import React, { FC } from 'react';
import styles from './nav_dropdown_footer.module.scss';

export const NavDropdownFooter: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
